import React from 'react';
import { Box, Chip, Divider } from '@mui/material';
import { formatDate } from '../../../../utilities/date-helper';
import { PageTitleZoneNext } from '../../../../components/page-title-zone';
import { CitizenNameDisplay } from '../../../../components/display/citizen-name-display';
import { AssignmentStatusType } from '../../../../api-service/clients';

export interface IAssignmentTitleZoneProps {
  isEditMode: boolean;
  isSocialProviderContext?: boolean;
  name?: string;
  status?: AssignmentStatusType;
  startDate?: Date;
  endDate?: Date;
}

function getStatusLabel(status: AssignmentStatusType): string {
  switch (status) {
    case AssignmentStatusType.Draft:
      return 'Kladde';
    case AssignmentStatusType.Current:
      return 'Aktuel';
    case AssignmentStatusType.Historic:
      return 'Historisk';
    default:
      return '';
  }
}

function getStatusColor(status: AssignmentStatusType): 'default' | 'success' | 'secondary' | 'warning' {
  switch (status) {
    case AssignmentStatusType.Draft:
      return 'warning';
    case AssignmentStatusType.Current:
      return 'success';
    case AssignmentStatusType.Historic:
      return 'secondary';
    default:
      return 'default';
  }
}

export function AssignmentTitlezone(props: IAssignmentTitleZoneProps) {
  const { isEditMode, isSocialProviderContext, status, name, startDate, endDate } = props;

  const title = isEditMode ? 'Redigér bestilling' : 'Opret bestilling';

  const entityNameWithStatus = (
    <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
      <span>{name || 'Bestilling'}</span>
      {startDate && (
        <>
          <Divider orientation="vertical" flexItem sx={{ alignSelf: 'stretch', my: 0.25 }} />
          <span>{formatDate(startDate)} {endDate ? `til ${formatDate(endDate)}` : ''}</span>
        </>
      )}
      {status && (
        <>
          <Divider orientation="vertical" flexItem sx={{ alignSelf: 'stretch', my: 0.25 }} />
          <Chip
            label={getStatusLabel(status)}
            color={getStatusColor(status)}
            size="small"
            sx={{ fontWeight: 500 }}
          />
        </>
      )}
    </Box>
  );

  return (
    <PageTitleZoneNext
      isLoading={false}
      entityName={entityNameWithStatus}
      title={title}
      subtitle={<CitizenNameDisplay isSocialProviderContext={isSocialProviderContext} />}
      isSocialProviderContext={isSocialProviderContext}
    />
  );
}
